import type { ButtonHTMLAttributes } from 'react';

interface BigButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
}

// A deliberately large, high-contrast button. The "9 year old on a phone in 30 seconds" test
// rewards big touch targets, clear labels, and plenty of white space around them.
export function BigButton({
  variant = 'primary',
  className = '',
  children,
  ...rest
}: BigButtonProps) {
  const base =
    'w-full min-h-[64px] rounded-2xl font-medium text-lg transition active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-accent/40';
  const styles =
    variant === 'primary'
      ? 'bg-accent text-white shadow-lg shadow-accent/20 hover:brightness-105'
      : 'bg-white text-ink border border-ink/10 hover:bg-warm';
  return (
    <button className={`${base} ${styles} ${className}`} {...rest}>
      {children}
    </button>
  );
}
